//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { SamplingOpportunitiesSortBy } from '@apis/campaign-requests/sampling/opportunities/samplingOpportunitiesApiModel';
import { PurchaseOptionsSortKey } from '@campaigns/constants/sampling/SamplingCampaignRequestConstants';

/**
 * Converts a PurchaseOptionsSortKey to the corresponding API sort parameter
 */
export const getSortParam = (
  sortKey: PurchaseOptionsSortKey,
): SamplingOpportunitiesSortBy => {
  switch (sortKey) {
    case PurchaseOptionsSortKey.EXPIRY_DATE:
      return SamplingOpportunitiesSortBy.expiryDate;
    case PurchaseOptionsSortKey.BALANCE:
      return SamplingOpportunitiesSortBy.balance;
    default:
      return SamplingOpportunitiesSortBy.expiryDate;
  }
};
